<template>
    <div class="m-portlet m-portlet--head-sm" :class="{'m-portlet--collapse' : !isOpen }" m-portlet="true" id="m_portlet_tools_4">
        <div class="m-portlet__head filters">
            <div class="m-portlet__head-caption">
                <div class="m-portlet__head-title">
                    <h3 class="m-portlet__head-text">
                        {{ labels.advanced_filters_title }}
                    </h3>
                </div>
            </div>
            <div class="m-portlet__head-tools">
                <ul class="m-portlet__nav">
                    <li class="m-portlet__nav-item">
                        <a @click.prevent="togglePortlet" href="" m-portlet-tool="toggle" class="m-portlet__nav-link m-portlet__nav-link--icon" aria-describedby="tooltip_3xmztoxj1y"><i class="la la-angle-down"></i></a>
                        <div class="m-tooltip m-tooltip--portlet tooltip bs-tooltip-top" role="tooltip" id="tooltip_3xmztoxj1y" aria-hidden="true" x-placement="top" style="position: absolute; will-change: transform; visibility: hidden; top: 0px; left: 0px; transform: translate3d(288px, -32px, 0px);">
                            <div class="tooltip-arrow arrow" style="left: 39px;"></div>
                            <div class="tooltip-inner">Expand</div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="m-portlet__body" :style="bodyStyle">
            <div class="">
                <div class="row" style="text-align: center;">
                    <div class="col-1"></div>
                    <div class="col-3" id="toggle-refinement1"></div>
                    <div class="col-3" id="toggle-refinement2"></div>
                    <div class="col-3" id="toggle-refinement3"></div>
                </div>

                <!-- ADVANCED FILTERS -->
                <div id="advancedFilters">
                    <h6>{{ labels.advanced_filters_helper }} : </h6>

                    <ul class="advanced-filters-parent"></ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import { connectConfigure } from 'instantsearch.js/es/connectors'
import { toggleRefinement } from 'instantsearch.js/es/widgets'

const searchableAttributes = ['brandName', 'collectionName', 'listINCI', 'relatedINCI', 'claims', 'ingredients', 'name']

let refineAttributesTimer

export default {
    props: ['search'],
    data () {
        return {
            isOpen: true
        }
    },
    computed: {
        ...mapState({
            labels: state => state.labels,
            selectedProductIds: store => store.products.selectedProductIds,
            lastSearch: store => store.products.lastSearch
        }),
        bodyStyle () {
            if (!this.isOpen) {
                return 'display: none; overflow: hidden; padding-top: 0px; padding-bottom: 0px;'
            }
            return ''
        }
    },
    methods: {
        ...mapActions('products', [
            'setSelectedProducts',
            'toggleCheckBoxes',
            'storeLastQuery'
        ]),
        togglePortlet () {
            this.isOpen = !this.isOpen
        },
        toggleRefinementWidget () {
            var my = this
            // isNaos facet filter
            this.search.addWidget(
                toggleRefinement({
                    container: '#toggle-refinement1',
                    attribute: 'isNaos',
                    on: false,
                    templates: {
                        labelText: my.labels.productFilters.isNaos
                    }
                })
            )
            // hasINCI facet filter
            this.search.addWidget(
                toggleRefinement({
                    container: '#toggle-refinement2',
                    attribute: 'hasINCI',
                    on: false,
                    templates: {
                        labelText: my.labels.productFilters.hasINCI
                    }
                })
            )
            // hasCommentCIP facet filter
            this.search.addWidget(
                toggleRefinement({
                    container: '#toggle-refinement3',
                    attribute: 'hasCommentCIP',
                    on: false,
                    templates: {
                        labelText: my.labels.productFilters.hasCommentCIP
                    }
                })
            )

            $(document).on('input', '.ais-ToggleRefinement-checkbox', function () {
                // Deselect any selected products
                if (my.selectedProductIds.length) {
                    my.toggleCheckBoxes(false)
                    my.setSelectedProducts(null)
                }
            })
        },
        renderAdvancedFilters () {
            var my = this
            // 1. Create a render function
            const renderConfigure = (renderOptions, isFirstRender) => {
                // Rendering logic
                const { refine, widgetParams } = renderOptions

                var restrictSearchableAttributes = this.search.helper.state.restrictSearchableAttributes
                if (isFirstRender && this.lastSearch && this.lastSearch.hasOwnProperty('restrictSearchableAttributes')) {
                    restrictSearchableAttributes = this.lastSearch.restrictSearchableAttributes
                    refine({
                        restrictSearchableAttributes
                    })
                    this.storeLastQuery(null)
                }

                var itemDisplayName;
                widgetParams.container.querySelector('ul').innerHTML = searchableAttributes
                    .map(item => {
                        item === 'claims' ? itemDisplayName = 'claimsEfficiency' : itemDisplayName = item

                        if (restrictSearchableAttributes.indexOf(itemDisplayName) !== -1) {
                            return `
                                <li class="advanced-filters-list">
                                  <label class="kt-checkbox">
                                    <input type="checkbox" data-name="${item}" checked/>
                                    ${my.labels.productFilters[item]}
                                    <span></span>
                                  </label>
                                </li>
                            `
                        } else {
                            return `
                                <li class="advanced-filters-list">
                                  <label class="kt-checkbox">
                                    <input type="checkbox" data-name="${item}"/>
                                    ${my.labels.productFilters[item]}
                                    <span></span>
                                  </label>
                                </li>
                            `
                        }
                    })
                    .join('');

                [...widgetParams.container.querySelectorAll('input')].forEach(element => {
                    element.addEventListener('change', event => {
                        my.handleCustomRefinementInput(event.currentTarget.dataset.name, refine, restrictSearchableAttributes, event.currentTarget.checked)
                        // Deselect any selected products
                        if (my.selectedProductIds.length) {
                            my.toggleCheckBoxes(false)
                            my.setSelectedProducts(null)
                        }
                    })
                })
            }

            // 2. Create the custom widget
            const customConfigure = connectConfigure(
                renderConfigure
            )

            // 3. Instantiate
            this.search.addWidget(
                customConfigure({
                    container: document.getElementById('advancedFilters'),
                    searchParameters: {
                        restrictSearchableAttributes: []
                    }
                })
            )
        },
        handleCustomRefinementInput (name, refine, restrictSearchableAttributes, checked) {
            if (name === 'claims') {
                this.updateSearchableAttributes('claimsEfficiency', refine, restrictSearchableAttributes, checked)
                this.updateSearchableAttributes('claimsSecurity', refine, restrictSearchableAttributes, checked)
            } else {
                this.updateSearchableAttributes(name, refine, restrictSearchableAttributes, checked)
            }
        },
        updateSearchableAttributes (name, refine, restrictSearchableAttributes, checked) {
            var indexOf = restrictSearchableAttributes.indexOf(name)
            if (checked && indexOf === -1) {
                restrictSearchableAttributes.push(name)
            } else if (indexOf >= 0) {
                restrictSearchableAttributes.splice(indexOf, 1)
            }
            clearTimeout(refineAttributesTimer)
            refineAttributesTimer = setTimeout(refine({
                restrictSearchableAttributes
            }), 50)
        }
    },
    mounted () {
        this.renderAdvancedFilters()
        this.toggleRefinementWidget()
    },
    beforeDestroy () {
        $(document).off('input', '.ais-ToggleRefinement-checkbox')
    }
}
</script>

<style>
    .advanced-filters-parent {
        list-style: none;
        display: flex;
    }
    .advanced-filters-list {
        margin-left: 7px;
        padding: 5px;
    }
    .ais-ToggleRefinement-labelText {
        margin-left: 20px;
    }
    .ais-ToggleRefinement-checkbox {
        border-radius: 3px;
        background: none;
        position: absolute;
        height: 15px;
        width: 15px;
        border: 1px solid #f4f5f8;
    }
    #advancedFilters h6 {
        margin: 20px 0 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Products/AllProducts/AdvancedFilters.vue